import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../http";

export interface SysCompanyTenant {
    id: number;
    companyId: number;
    provider: string;
    tenantId: string;
    tenantName: string;
    defaultDomain: string;
    isActive: boolean;
    allowSelfRegistration: boolean;
    allowExternalUsers: boolean;
}

export interface SaveSysCompanyTenantPayload {
    id?: number;
    companyId: number;
    provider: string;
    tenantId: string;
    tenantName: string;
    defaultDomain: string;
    isActive: boolean;
    allowSelfRegistration: boolean;
    allowExternalUsers: boolean;
}

export const loadCompanySSOSettings = createAsyncThunk<SysCompanyTenant[], string, AppThunkAPIType>("company-sso-settings/load", async (companyId, { dispatch, rejectWithValue }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-tenants/company/${companyId}` }))
    const { payload } = result

    if (getWithAuth.fulfilled.match(result)) {
        return payload as SysCompanyTenant[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createCompanySSOSetting = createAsyncThunk<SysCompanyTenant, SaveSysCompanyTenantPayload, AppThunkAPIType>("company-sso-settings/create", async (tenant, { dispatch, rejectWithValue }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-tenants`, payload: tenant }))
    const { payload } = result

    if (postWithAuth.fulfilled.match(result)) {
        return payload as SysCompanyTenant
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateCompanySSOSetting = createAsyncThunk<SysCompanyTenant, SaveSysCompanyTenantPayload, AppThunkAPIType>("company-sso-settings/update", async (tenant, { dispatch, rejectWithValue }) => {
    const result = await dispatch(putWithAuth({ url: `api/sys/company-tenants/${tenant.id}`, payload: tenant }))
    const { payload } = result

    if (putWithAuth.fulfilled.match(result)) {
        return payload as SysCompanyTenant
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const deleteCompanySSOSetting = createAsyncThunk<number, number, AppThunkAPIType>("company-sso-settings/delete", async (id, { dispatch, rejectWithValue }) => {
    const result = await dispatch(deleteWithAuth({ url: `api/sys/company-tenants/${id}` }))
    const { payload } = result

    if (deleteWithAuth.fulfilled.match(result)) {
        return typeof payload === "number" ? payload : id
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const activateCompanySSOSetting = createAsyncThunk<SysCompanyTenant, number, AppThunkAPIType>("company-sso-settings/activate", async (id, { dispatch, rejectWithValue }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-tenants/${id}/activate`, payload: {} }))
    const { payload } = result

    if (postWithAuth.fulfilled.match(result)) {
        return payload as SysCompanyTenant
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const deactivateCompanySSOSetting = createAsyncThunk<SysCompanyTenant, number, AppThunkAPIType>("company-sso-settings/deactivate", async (id, { dispatch, rejectWithValue }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-tenants/${id}/deactivate`, payload: {} }))
    const { payload } = result

    if (postWithAuth.fulfilled.match(result)) {
        return payload as SysCompanyTenant
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})